import React from "react";

import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./styles.css";
const ReModal = ({
  open,
  setOpen,
  handleOpen,
  handleClose,
}) => {
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <br />
        <h1
          className="modal-heading"
          style={{ borderBottom: "1px solid white" }}
        >
          ORIENTATION TRAINING FOR IMPROVED LOCAL GOVERNANCE
          HELD FOR PROVINCIAL ASSEMBLY MEMBERS OF KHYBER
          PAKHTUNKHWA FROM MERGED
        </h1>
        <hr />
        <p className="modal-para">
          <img
            className="modal-img"
            src="https://lgkp.gov.pk/wp-content/uploads/2016/06/Notification-regarding-Directorate-of-Coordination.jpg"
            alt=""
            style={{
              width: "250px",
              height: "250px",
              float: "left",
              padding: "10px",
            }}
          />
          An effort to move forward the implementation of
          post-merger reforms in tribal districts of Khyber
          Pakhtunkhwa, GIZ in collaboration with the Local
          Government, Elections and Rural Development
          Department (LGE&RDD) of Khyber Pakhtunkhwa (KP)
          and KP Assembly, organized a three-and-a-half-day
          orientation workshop on Local Government System
          and Parliamentary Proceedings for members of
          Provincial Assembly (MPAs) from the Merged Areas
          and settled districts of Khyber Pakhtunkhwa with
          the special auspices of Hon. Mushtaq Ahmed Ghani,
          Speaker of KP Assembly and Mr. Nasrullah Khan
          Khattak, Secretary KP Assembly.
        </p>
        <div className="modal-date">29-10-2021</div>
      </Modal>
    </>
  );
};

export default ReModal;
